import style from "./alerts.module.scss";
import {warningAlert} from "../../util/assets";
import aqiIcon from "../../assets/aqi-icon.png";
import moment from "moment";
import {Scrollbars} from "react-custom-scrollbars-2";
import React, {useRef, useState} from "react";
import {connect} from "react-redux";
import {hideAlerts, showHideAlerts} from "../../action/alert";
import {colors, useOutsideAlerter} from "../../util/util";
import {setCurrentItem} from "../../action/page";
import {moderateFaceGray} from "../../util/assets";
import CloseIcon from '@mui/icons-material/Close';
import {getLogs} from "../../thunk/device";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

function Alerts({alerts, badges, showHideAlerts, hideAlerts, setCurrentItem, data, getLogs}) {
    const alertRef = useRef(null);
    useOutsideAlerter(alertRef, hideAlerts);

    const [active, setActive] = useState(true);

    const handlerShowStatus = (aqiFrom, aqiTo) => {
        const colorAqiFrom = colors[aqiFrom] ? colors[aqiFrom].toUpperCase() : "";
        const colorAqiTo = colors[aqiTo] ? colors[aqiTo].toUpperCase() : "";
        let nameStatusAqiFrom = badges.find(item => item.color.toUpperCase() === colorAqiFrom);
        let nameStatusAqiTo = badges.find(item => item.color.toUpperCase() === colorAqiTo);
        nameStatusAqiFrom = nameStatusAqiFrom ? nameStatusAqiFrom.title : "";
        nameStatusAqiTo = nameStatusAqiTo ? nameStatusAqiTo.title : "";
        return (
            <span>
                <span
                    style={{
                        background: colorAqiFrom,
                        color: colorAqiFrom === "#F6E604" ? "#707070" : "#fff"
                    }}
                >
                    {nameStatusAqiFrom}
                </span>
                {" "}to{" "}
                <span
                    style={{
                        background: colorAqiTo,
                        color: colorAqiTo === "#F6E604" ? "#707070" : "#fff"
                    }}
                >
                    {nameStatusAqiTo}
                </span>
            </span>
        );
    };

    const handlerChangeStatus = (item) => {
        // let device = data.find(i => i._id === item.deviceId);
        // debugger;
        getLogs({id: item.deviceId});
        // device._id = "";
        // setCurrentItem(device?{...device, active: true}:{});
        // showHideAlerts(!alerts.active);
    };

    return (
        <div className={[style.alertsRow, active ? style.active : ""].join(" ")}>
            <div className={style.activeButton} onClick={() => setActive(!active)}>{active ? <CloseIcon /> : <ArrowBackIosNewIcon />}</div>
            <div className={[style.alertRow].join(" ")} ref={alertRef}>
                <div
                    className={style.header}
                    onClick={() => showHideAlerts(!alerts.active)}
                >
                    <img src={warningAlert} alt=""/>
                    <span>System Events</span>
                </div>

                <div className={[style.alertList, style.active].join(" ")}>
                    <Scrollbars style={{height: "250px"}}>
                        {alerts.baseAlerts.map((item, index) =>
                            item.show ? (
                                <div
                                    className={style.alertItem}
                                    key={`alert_${index}`}
                                    onClick={() => handlerChangeStatus(item)}
                                >
                                    {item.type === "waqi" && <img src={aqiIcon} alt="" className={style.alertIcon}/>}
                                    {handlerShowStatus(item.aqiFrom, item.aqiTo)}
                                    {` | ${moment(item.created_at).format("dddd, LT")}`}
                                </div>
                            ) : null
                        )}
                    </Scrollbars>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    alerts: state.alerts,
    badges: state.page.badges,
    data: state.page.data
});

const mapDispatchToProps = dispatch => ({
    showHideAlerts: data => dispatch(showHideAlerts(data)),
    hideAlerts: data => dispatch(hideAlerts(data)),
    setCurrentItem: data => dispatch(setCurrentItem(data)),
    getLogs: data => dispatch(getLogs(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
